export default __webpack_public_path__ + "static/media/bettair_logo.72ee3720.png";